const { getTaxonomyIds } = require('./getTaxonomyIds');
const { getRelatedShowPageData } = require('../show/showUtils');
const { getHubPage } = require('../hubPage/hubPageUtils');
const { mainTaxFields, allTaxFields } = require('./taxFieldsConfig');

const getTaxonomyData = taxonomyEntity => {
  const { hubPage } = taxonomyEntity;
  return {
    id: taxonomyEntity.tid,
    name: hubPage ? hubPage.title : taxonomyEntity.name,
    url: taxonomyEntity.hubPage?.url
  };
};

const getTaxonomies = (
  content,
  options = {
    includeShowPage: true,
    includeParents: false,
    useAllTaxonomies: false,
    allowPttsWithoutHubPage: false
  }
) => {
  // Use an object to avoid duplicates
  const taxonomies = {};

  if (options.includeShowPage) {
    const relatedShowPageData = getRelatedShowPageData(content);
    // If content has a relation with "show_page", treat it as a taxonomy
    if (relatedShowPageData) {
      taxonomies[relatedShowPageData.url] = relatedShowPageData;
    }
  }

  const taxFields = options.useAllTaxonomies ? allTaxFields : mainTaxFields;
  taxFields.forEach(taxonomyName => {
    if (typeof content[taxonomyName] !== 'undefined') {
      content[taxonomyName].forEach(taxonomyEntity => {
        if (taxonomyEntity.entity?.tid) {
          taxonomies[taxonomyEntity.entity.tid] = getTaxonomyData(
            taxonomyEntity.entity
          );
          if (options.includeParents && taxonomyEntity.entity.parents) {
            taxonomyEntity.entity.parents.forEach(parent => {
              taxonomies[parent.tid] = {
                ...getTaxonomyData(parent),
                isParent: true
              };
            });
          }
        }
      });
    }
  });
  const hubPagesData = content.hubpages;
  if (hubPagesData) {
    hubPagesData.forEach(hubPageData => {
      taxonomies[hubPageData.tid] = {
        id: hubPageData.tid,
        name: hubPageData.title,
        url: hubPageData.url,
        isPtt: false
      };
    });
  }
  // Add PTT now to ensure it overwrites any possible duplicate.
  if (content.primaryTaxonomy?.entity?.tid) {
    const hubPage = getHubPage(content);
    if (hubPage || options.allowPttsWithoutHubPage) {
      taxonomies[content.primaryTaxonomy.entity.tid] = {
        id: content.primaryTaxonomy.entity.tid,
        name: hubPage?.title || content.primaryTaxonomy.entity.name,
        url: hubPage?.url,
        isPtt: true
      };
    }
  }

  // No need to sort Object.keys because when all keys are numbers,
  // it returns an already sorted array.
  // Object.keys({ 100: 'a', 2: 'b', 7: 'c' })); ===> ['2', '7', '100']
  // @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/keys
  return Object.keys(taxonomies).map(tid => taxonomies[tid]);
};

const getTaxonomyAncestorSlugs = (
  content,
  options = { useAllTaxonomies: false }
) => {
  // Use an object to avoid duplicates
  const ancestorSlugs = [];

  const taxFields = options.useAllTaxonomies ? allTaxFields : mainTaxFields;
  taxFields.forEach(taxonomyName => {
    if (typeof content[taxonomyName] !== 'undefined') {
      content[taxonomyName].forEach(taxonomyEntity => {
        if (taxonomyEntity.entity?.ancestorsSlug) {
          ancestorSlugs.push(taxonomyEntity.entity.ancestorsSlug);
        }
      });
    }
  });

  return ancestorSlugs;
};

const getTaxonomySlug = taxonomy => {
  if (taxonomy.entity?.englishUrl) {
    return taxonomy.entity.englishUrl.replace('/', '');
  }
  return '';
};

const getPrimaryTaxonomySlug = content => {
  if (content.primaryTaxonomy) {
    return getTaxonomySlug(content.primaryTaxonomy);
  }
  return '';
};

const getPrimaryTaxonomyData = entity => {
  const tagData = { tag: '', tagUrl: '', slug: '' };
  if (entity.primaryTaxonomy) {
    tagData.slug = getPrimaryTaxonomySlug(entity);
    if (entity.primaryTaxonomy.entity.hubPage) {
      const hubPage = getHubPage(entity);

      if (hubPage) {
        tagData.tag = hubPage.title;
        tagData.tagUrl = hubPage.url;
      }
    }
  }
  return tagData;
};

const isEarth = term => term.uuid === 'eea9ad49-32fc-3a7c-bf15-cfeabdaa2fb7';

const isContinent = term => term.parents?.[0]?.englishName === 'Earth';

const isCountry = term => term.parents?.[1]?.englishName === 'Earth';

module.exports = {
  getTaxonomyIds,
  getTaxonomies,
  getTaxonomyAncestorSlugs,
  getPrimaryTaxonomySlug,
  getPrimaryTaxonomyData,
  isEarth,
  isContinent,
  isCountry
};
